import React from 'react'

const EmployeeDash = () => {
  return (
    <div>
      this is employee dashboard
    </div>
  )
}

export default EmployeeDash
